module.exports = __webpack_public_path__ + "img/home-two1.c51e42c9.png";